import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const UpsidedownTriangleIcon = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 404.308 303.229"
    className={className}
  >
    <path fill={fillColor} d="M0,0h404.308L202.151,303.229L0,0z" />
  </svg>
);

UpsidedownTriangleIcon.defaultProps = defaultProps;

export default UpsidedownTriangleIcon;
